import Set0 from 'data/bosses/set-00';

export default [...Set0];
